module.exports = __webpack_public_path__ + "img/添加录音.dd2fa40e.png";